module.exports = __webpack_public_path__ + "img/pruinfobg.ffd5a9b8.jpg";